import {
  Carousel,
  CarouselSlide,
} from '@monofront/design-system/components/Carousel';
import CardProductBasket from '@components/CardProductBasket';
import { ICollectionProductBasket } from '@monofront/types';

interface ICarouselProductBasketProps {
  collectionProductBasket?: ICollectionProductBasket | null;
}

export const CarouselProductBasket: React.FC<ICarouselProductBasketProps> = ({
  collectionProductBasket,
}) => {
  if (
    !collectionProductBasket ||
    !collectionProductBasket.products ||
    !collectionProductBasket.title
  ) {
    return null;
  }

  return (
    <div
      className={`
          [&_.swiper-container]:tw-px-px
          [&_.swiper-slide:last-child]:tw-border-r
          [&_.swiper-slide:last-child]:tw-border-solid
          [&_.swiper-slide:last-child]:tw-border-r-[#f5f5f5]
          [&_.swiper-slide]:tw-border-b
          [&_.swiper-slide]:tw-border-l
          [&_.swiper-slide]:tw-border-r-0
          [&_.swiper-slide]:tw-border-t
          [&_.swiper-slide]:tw-border-solid
          [&_.swiper-slide]:tw-border-b-[#f5f5f5]
          [&_.swiper-slide]:tw-border-l-[#f5f5f5]
          [&_.swiper-slide]:tw-border-t-[#f5f5f5]
          [&_h2]:tw-px-4
          desktop:[&_h2]:tw-px-px
        `}
    >
      <Carousel
        headerTitle={
          <>
            <h2>{collectionProductBasket.title}</h2>
            {collectionProductBasket.descriptionMobile && (
              <div
                className={`
                      tw-mb-6
                      tw-px-4
                      desktop:tw-hidden
                    `}
                dangerouslySetInnerHTML={{
                  __html: collectionProductBasket.descriptionMobile,
                }}
              ></div>
            )}
          </>
        }
        slidesPerView={1.8}
        navigation
        freeMode
        breakpoints={{
          800: {
            slidesPerView: 5,
            freeMode: false,
          },
        }}
      >
        {collectionProductBasket.products.map((productBasket, index) => {
          return (
            <CarouselSlide key={index}>
              <CardProductBasket
                productBasket={productBasket}
                key={productBasket.uid}
              />
            </CarouselSlide>
          );
        })}
      </Carousel>
    </div>
  );
};
